export const TEST_TYPES_FUNCTION_NAME = 'service-tests';

export const TEST_TYPES_TAB = 'test-types';
export const TESTS_TAB = 'tests';

export const DEFAULT_TAB = TEST_TYPES_TAB;
export const VALID_TABS = [TEST_TYPES_TAB, TESTS_TAB];

export const TEST_TYPES_URL = '/ipm/v1/open/testTypes/';
export const ADMIN_TEST_TYPES_URL = '/ipm/v1/admin/testTypes';
export const SERVICE_TESTS_URL = '/ngp/v2/service-tests/';

export const ADMIN_TESTS_URL = '/ipm/v1/admin/tests';
export const ADMIN_TESTS_UPDATE_SELECTION_URL = '/ipm/v1/admin/tests/selection/update';
export const SERVICE_TESTS_LIST_URL = '/ngp/v2/service-tests/list';
export const SERVICE_TESTS_DELETE_URL = '/ngp/v2/service-tests';
